var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5346_79989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.790232 2.85978L8.14707 11.4829C8.26566 11.6218 8.41276 11.7333 8.57828 11.8097C8.7438 11.8862 8.92383 11.9258 9.10602 11.9258C9.2882 11.9258 9.46824 11.8862 9.63376 11.8097C9.79928 11.7333 9.94638 11.6218 10.065 11.4829L17.4218 2.85978C18.1239 2.0367 17.5418 0.765334 16.4629 0.765333L1.74707 0.765331C0.668127 0.765331 0.0860213 2.0367 0.790232 2.85978Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5346_79989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 18,
    fill: "white",
    transform: "translate(0 12) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDown);
export default __webpack_public_path__ + "static/media/icon-down.279172ac6ddf8ba6c1519cec159e63ab.svg";
export { ForwardRef as ReactComponent };